import EditIcon from '@mui/icons-material/Edit';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { IconButton, ListItem, ListItemIcon, ListItemText, Stack } from '@mui/material';
import { useSelector } from 'react-redux';

import AmbulanceIcon from 'FRONTEND/components/Geolocation/AmbulanceIcon/AmbulanceIcon';
import { selectResourceById } from 'FRONTEND/reducers/resourceSlice';


const LocationItem = ({ location, onSelect, onEdit, disableCreation }) => {
  const resourceLocation = useSelector((state) => selectResourceById(state, location.station_id));
  return (
    <ListItem disablePadding>
      <ListItemIcon>
        <LocationOnIcon />
      </ListItemIcon>
      <ListItemText
        onClick={() => onSelect ? onSelect(location.id) : null}
        primary={location.description}
        secondary={location.address.city}
        primaryTypographyProps={{ fontSize: '1.1rem' }}
      />
      {!disableCreation && (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onEdit(location);
          }}
        >
          <EditIcon />
        </IconButton>
      )}
      {disableCreation && (
        <Stack direction='row' sx={{ alignItems: 'center', flex: 1 }}>
          <ListItemIcon>
            <AmbulanceIcon />
          </ListItemIcon>
          <ListItemText secondary={resourceLocation?.alias} />
        </Stack>
      )}
    </ListItem>
  );
};

export default LocationItem;
